<template>
  <div class="loader">
    <video width="70" autoplay loop>
      <source
        src="@/assets/loading/launch-loader-logo--light.mp4"
        type="video/mp4"
      />
    </video>
  </div>
</template>
<style scoped lang="scss">
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
